import React from "react";
import {graphql} from "react-apollo";
import {flowRight as compose} from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import Form, {prepareValuesForSubmission, rolesToOption, validateForm} from "./PartnerForm";
import {cancelEditPartner, successEditPartner} from "../../../actions/PartnerApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {GET_PARTNER} from "../../../queries/partners";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";

class EditPartnerFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = prepareValuesForSubmission(values).set("partnerId", this.props.partnerId);

    return this.props.updatePartner(data.toJS())
      .then((response) => {
        if (response.data.updatePartner.errors.length <= 0) {
          this.props.successEditPartner();
        } else {
          this.setState({errors: createValidationErrors(response.data.updatePartner.errors)});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  render() {
    const {loading, error, partner} = this.props.data;
    if (loading) return <Loading />;
    if (error) return <GraphQLErrors error={error} />;

    // Addresses are edited one at a time, from the partner's panel.
    const initialValues = fromJS({
      name: partner.name,
      roles: rolesToOption(partner.roles),
      contactName: partner.contactName,
      email: partner.email,
      phone: partner.phone,
      notes: partner.notes,
      active: partner.active,
    });

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelEditPartner()}
        />
    )
  }
}

const UPDATE_PARTNER = gql`
  mutation updatePartner($data: PartnerInput!) {
    updatePartner(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(GET_PARTNER, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: { partnerId: props.partnerId },
    })
  }),
  graphql(UPDATE_PARTNER, {
    props: ({ mutate }) => ({
      updatePartner: (data) => mutate({ variables: { data: data } })
    })
  })
);

export default connect(null, {cancelEditPartner, successEditPartner})(withQuery(EditPartnerFormContainer));
